import React, { useMemo, useRef } from 'react';
import { groups } from 'd3-array';
import ReactSelect from 'react-select';

const isSmallScreen = window.innerWidth < 700;

const overwriteFontSize = (provided) => ({
  ...provided,
  fontSize: isSmallScreen ? '12px' : '14px',
});

const ReactSelectStyles = {
  input: overwriteFontSize,
  placeholder: overwriteFontSize,
  singleValue: overwriteFontSize,
  menu: overwriteFontSize,
  control: (provided) => ({
    ...provided,
    backgroundColor: '#fff',
  }),
  container: (provided) => ({ ...provided, width: '100%' }),
  dropdownIndicator: (provided) => ({ ...provided, padding: isSmallScreen ? 0 : '8px' }),
  indicatorSeparator: (provided) => ({ ...provided, display: isSmallScreen ? 'none' : 'block' }),
};

export default function CustomReactSelect({ options, ...props }) {
  const selectRef = useRef();

  const scrollSelectedElement = () => {
    if (selectRef.current && selectRef.current.controlRef) {
      setTimeout(() => {
        const containerEl = selectRef.current.inputRef?.closest('.ReactSelect');
        const selectedOption = containerEl?.querySelector('.ReactSelect__option--is-selected');
        if (selectedOption) {
          selectedOption.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
        }
      }, 15);
    }
  };

  const groupedOptions = useMemo(
    () =>
      groups(options, (d) => d.group).reduce((res, curr) => {
        const [key, values] = curr;
        if (!key) {
          res = values.concat(res);
        } else {
          res.push({
            label: key,
            options: values,
          });
        }
        return res;
      }, []),
    [options]
  );

  return (
    <ReactSelect
      onMenuOpen={scrollSelectedElement}
      ref={selectRef}
      styles={ReactSelectStyles}
      options={groupedOptions}
      className="ReactSelect"
      classNamePrefix="ReactSelect"
      defaultMenuIsOpen={false}
      {...props}
    />
  );
}
